import { createIcon } from '../icon'
import CheckIconFilled from '../svg/CheckIconFilled'

export const CheckIconFilledDefault = createIcon(CheckIconFilled)
